import React from 'react';

// AI-powered support glyph (from provided artwork), normalized to a 24x24
// viewBox so it inherits the shared BrandIcon color + stroke treatment.
export const AiSupport = ({ className, strokeWidth = 2.5, ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 1 L12 7 M12 17 L12 23 M4 8.8 L8.8 10.4 M15.2 10.4 L20 8.8 M4 15.2 L8.8 13.6 M15.2 13.6 L20 15.2" />
    <circle cx="12" cy="12" r="3.8" />
  </svg>
);

export default AiSupport;
